<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Radio type="button" v-model="reportType" :datas="typeDatas" @change="loadList"></Radio>
      </Cell>
      <Cell>
        <DatePicker v-model="startDate" format="yyyy-MM-dd" placeholder="开始日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <DatePicker v-model="endDate" format="yyyy-MM-dd" placeholder="结束日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadList">查询</Button>
      </Cell>
      <Cell>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>

    <!--收发汇总-->
    <div v-if="reportType === 'summary'" class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading">
        <TableItem title="商品编码" prop="materialCode" :width="130"></TableItem>
        <TableItem title="商品名称" prop="materialName" :width="160"></TableItem>
        <TableItem title="规格" prop="materialSpec" :width="110"></TableItem>
        <TableItem title="单位" prop="unit" :width="70"></TableItem>
        <TableItem title="期初数量" prop="openQty" align="right" :width="110"></TableItem>
        <TableItem title="期初金额" prop="openAmount" align="right" :width="110"></TableItem>
        <TableItem title="入库数量" prop="inQty" align="right" :width="110"></TableItem>
        <TableItem title="入库金额" prop="inAmount" align="right" :width="110"></TableItem>
        <TableItem title="出库数量" prop="outQty" align="right" :width="110"></TableItem>
        <TableItem title="出库金额" prop="outAmount" align="right" :width="110"></TableItem>
        <TableItem title="结余数量" prop="balanceQty" align="right" :width="110"></TableItem>
        <TableItem title="结余金额" prop="balanceAmount" align="right" :width="110"></TableItem>
      </Table>
    </div>

    <!--收发明细-->
    <div v-else class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading">
        <TableItem title="商品编码" prop="materialCode" :width="120"></TableItem>
        <TableItem title="商品名称" prop="materialName" :width="150"></TableItem>
        <TableItem title="规格" prop="materialSpec" :width="100"></TableItem>
        <TableItem title="单位" prop="unit" :width="60"></TableItem>
        <TableItem title="单据日期" prop="billDate" :width="100"></TableItem>
        <TableItem title="单据编号" prop="orderCode" :width="160"></TableItem>
        <TableItem title="业务类型" prop="bizType" :width="90"></TableItem>
        <TableItem title="往来单位" prop="partyName" :width="140"></TableItem>
        <TableItem title="入库数量" prop="inQty" align="right" :width="90"></TableItem>
        <TableItem title="入库金额" prop="inAmount" align="right" :width="100"></TableItem>
        <TableItem title="出库数量" prop="outQty" align="right" :width="90"></TableItem>
        <TableItem title="出库金额" prop="outAmount" align="right" :width="100"></TableItem>
        <TableItem title="结存数量" prop="balanceQty" align="right" :width="100"></TableItem>
        <TableItem title="单位成本" prop="unitCost" align="right" :width="100"></TableItem>
        <TableItem title="结存金额" prop="balanceAmount" align="right" :width="110"></TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryReport',
  data() {
    let now = new Date();
    let first = new Date(now.getFullYear(), 0, 1);
    return {
      reportType: 'summary',
      typeDatas: [{key: 'summary', title: '收发汇总'}, {key: 'detail', title: '收发明细'}],
      startDate: first,
      endDate: now,
      list: [],
      loading: false
    };
  },
  methods: {
    fmt(d) {
      let dt = d instanceof Date ? d : new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    },
    loadList() {
      this.loading = true;
      let p = {
        startDate: this.startDate ? this.fmt(this.startDate) : '',
        endDate: this.endDate ? this.fmt(this.endDate) : ''
      };
      let req = this.reportType === 'summary'
        ? this.$api.pro.inventory.summary(p)
        : this.$api.pro.inventory.detail(p);
      req.then(({data}) => {
        this.list = data || [];
      }).finally(() => this.loading = false);
    },
    doExport() {
      if (!this.list.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      let csv = this.list.map(r => Object.keys(r).map(k => `"${String(r[k] == null ? '' : r[k]).replace(/"/g, '""')}"`).join(',')).join('\n');
      let blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8'});
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = this.reportType === 'summary' ? '收发汇总表.csv' : '收发明细表.csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>
